import { NextRequest, NextResponse } from 'next/server';
import { v4 as uuid } from 'uuid';

export const ACTIVITY_ID_COOKIE_KEY = 'xappActivityId';

export const setActivityId = (req: NextRequest, res: NextResponse) => {
  if (req.cookies.get(ACTIVITY_ID_COOKIE_KEY)?.value) {
    return; // Activity ID already exists, no need to set a new one
  }

  const newActivityId = uuid();
  res.cookies.set(ACTIVITY_ID_COOKIE_KEY, newActivityId);
};
